
export default async function LogoutAction() {
	sessionStorage.clear();
}